
import { IModel, IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from './copysource';

@Metamodel.model({
    abstract: true
})
export abstract class FileTypeCopySource extends CopySource {
    public static readonly MODEL: IModel;
    public static readonly RECURSIVE_SETTING: IAttribute;
    public static readonly MAXCONCURRENT_CONNECTIONS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'RECURSIVE_SETTING',
        display: stringResources.Recursive_Copy_Label
    })
    public recursive: boolean = true;

    @Metamodel.attribute({
        templatable: true,
        association: 'MAXCONCURRENT_CONNECTIONS',
        display: stringResources.ModelName_MaxConcurrentConnections,
        constraint: {
            whole: true,
            minimum: 0
        }
    })
    public maxConcurrentConnections?: number;
}
